import API from '../../services/API'
import Storage from '@/utils/Storage'

export async function getConfiguration(ctx: any) {
    const configuration = await API.getConfiguration()
    ctx.commit('SET_CONFIGURATION', { configuration })

    return configuration
}

export async function setMaintenance(ctx: any, maintenance: boolean) {
    ctx.commit('SET_MAINTENANCE', { maintenance })
}

export async function getHeaderConfiguration(ctx: any) {
    if (ctx.state.headerConfiguration === null) {
        const configStorage = Storage.get('header_configuration')
        if (configStorage === null) {
            const config = await API.getHeaderConfig()
            ctx.commit('SET_HEADER_CONFIG', config.data)
            Storage.set('header_configuration', config.data, 1000 * 60 * 60) // 1 hour
        } else {
            ctx.commit('SET_HEADER_CONFIG', configStorage)
        }
    }
}
